// Works with new and old customizer
var check_for_toddler_title = function () {
    $(".separation-of-kids-bed").html(product_title_original);
}
var initOnVariantClick = function () {
    $(".customizer-option-list label").on("click", function () {
        if(tottler_product == false){
            var $size_variant_div = $(this).parent();
            var $size_variant_input = $size_variant_div.find("input");
            var size_variant_value = $size_variant_input.val();
            var is_this_toddler = false;
            for (let i = 0; i < toddler_sizes.length; i++) {
                if(size_variant_value == toddler_sizes[i]){
                    is_this_toddler = true;
                }
            }
            var toddler_title = toddler_title_prefix + product_title_original;
            if(is_this_toddler){
                $(".separation-of-kids-bed").html(toddler_title);
            }
            else{
                $(".separation-of-kids-bed").html(product_title_original);
            }
        }
    });
}
initOnVariantClick();